import type { MenuItem, NavbarAuth, NavbarLogo } from '@/components/navbar'

/**
 * The site's shared navigation configuration, consumed by the global shell
 * (`AppLayout`).
 *
 * TODO: These should eventually come from a CMS or i18n.
 */
export const siteLogo: NavbarLogo = {
    url: '/',
    src: '/next-static/logos/chiku-and-wanderu-horizontal.svg',
    width: 192,
    height: 44,
    alt: 'logo',
}

export const siteMenu: MenuItem[] = [
    {
        title: 'Buses',
        url: '/en-us/bus-tickets/',
        items: [
            { title: 'Boston to NYC bus', url: '/en-us/bus/us-ma/boston/us-ny/new-york/' },
            { title: 'NYC to Boston bus', url: '/en-us/bus/us-ny/new-york/us-ma/boston/' },
            { title: 'DC to NYC bus', url: '/en-us/bus/us-dc/washington/us-ny/new-york/' },
            { title: 'LA to Vegas bus', url: '/en-us/bus/us-ca/los-angeles/us-nv/las-vegas/' },
            { title: 'Dallas to Houston bus', url: '/en-us/bus/us-tx/dallas/us-tx/houston/' },
            { title: 'Houston to Dallas bus', url: '/en-us/bus/us-tx/houston/us-tx/dallas/' },
            {
                title: 'Baltimore to NYC bus',
                url: '/en-us/bus/us-md/baltimore/us-ny/new-york/',
            },
            { title: 'NYC to Albany bus', url: '/en-us/bus/us-ny/new-york/us-ny/albany/' },
            { title: 'Orlando to Miami bus', url: '/en-us/bus/us-fl/orlando/us-fl/miami/' },
            {
                title: 'Philadelphia to NYC bus',
                url: '/en-us/bus/us-pa/philadelphia/us-ny/new-york/',
            },
        ],
    },
    {
        title: 'Trains',
        url: '/en-us/train-tickets/',
        items: [
            { title: 'Boston to NYC train', url: '/en-us/train/us-ma/boston/us-ny/new-york/' },
            { title: 'NYC to Boston train', url: '/en-us/train/us-ny/new-york/us-ma/boston/' },
            { title: 'DC to NYC train', url: '/en-us/train/us-dc/washington/us-ny/new-york/' },
            { title: 'NYC to DC train', url: '/en-us/train/us-ny/new-york/us-dc/washington/' },
            {
                title: 'San Diego to LA train',
                url: '/en-us/train/us-ca/san-diego/us-ca/los-angeles/',
            },
            {
                title: 'LA to San Diego train',
                url: '/en-us/train/us-ca/los-angeles/us-ca/san-diego/',
            },
            {
                title: 'Seattle to Vancouver train',
                url: '/en-us/train/us-wa/seattle/ca-bc/vancouver/',
            },
            {
                title: 'Vancouver to Seattle train',
                url: '/en-us/train/ca-bc/vancouver/us-wa/seattle/',
            },
            {
                title: 'Philadelphia to NYC train',
                url: '/en-us/train/us-pa/philadelphia/us-ny/new-york/',
            },
            {
                title: 'NYC to Baltimore train',
                url: '/en-us/train/us-ny/new-york/us-md/baltimore/',
            },
            { title: 'Newark to DC train', url: '/en-us/train/us-nj/newark/us-dc/washington/' },
        ],
    },
    {
        title: 'Bus & Train Companies',
        shortTitle: 'Carriers',
        url: '/en-us/carrier/',
        items: [
            { title: 'Amtrak', url: '/en-us/carrier/amtrak-train-146/' },
            { title: 'Acela', url: '/en-us/carrier/acela-182/' },
            { title: 'Greyhound Bus', url: '/en-us/carrier/greyhound-bus-lines-139/' },
            { title: 'FlixBus USA', url: '/en-us/carrier/flixbus-us-1956/' },
            { title: 'Peter Pan Bus', url: '/en-us/carrier/peter-pan-bus-lines-132/' },
            { title: 'Red Coach', url: '/en-us/carrier/red-coach-148/' },
            { title: 'California Zephyr', url: '/en-us/carrier/amtrak-california-zephyr-186/' },
            { title: 'All Companies', url: '/en-us/carrier/' },
        ],
    },
    // Neither path is a nexus route: /en-us/find-tickets/ is canopy, the search-funnel
    // frontend, and /en-us/explore/ 302s to it at the Cloudflare edge. Link the
    // destination so the shell doesn't spend a hop on every page that renders the nav.
    { title: 'Explore', url: '/en-us/find-tickets/' },
    { title: 'Blog', url: '/blog/' },
]

export const siteAuth: NavbarAuth = {
    login: {
        title: 'Login',
        url: '/en-us/account/login/',
    },
    signup: {
        title: 'Sign Up',
        url: '/en-us/account/signup/',
    },
    myTrips: {
        title: 'My Trips',
        url: '/en-us/account/my-trips/',
    },
    account: {
        title: 'Account',
        url: '/en-us/account/settings/',
    },
    points: {
        title: 'Points',
        url: '/en-us/account/points/',
    },
}

// Trailing slash required: `trailingSlash: true` (next.config) 308s `/blog`,
// and this is the blog masthead's brand link on every blog page.
export const blogUrl = '/blog/'
